import { Col, Row } from "react-bootstrap";
import MaterialIcon, { MtIcon } from "../../material-icon/material-icon";
import styles from "./button-with-badge.module.scss";

interface IProps {
  badgeValue?: number;
  text: string;
  icon?: MtIcon;
  onClick: () => void;
}

const ButtonWithBadge = (props: IProps) => {
  const { badgeValue, text, icon, onClick, ...rest } = props;

  return (
    <button
      {...{
        ...rest,
        className: `text-decoration-none ${styles.button} px-3`,
      }}
      onClick={onClick}
    >
      <Row className="justify-content-center align-items-center g-2">
        {icon && (
          <Col className={`col-auto ${badgeValue && `mb-3`}`}>
            {badgeValue ? (
              <div className={`${styles.badge}`}>{badgeValue}</div>
            ) : (
              <></>
            )}

            <MaterialIcon
              size={17}
              icon={icon}
              color="var(--color-visibility-icon)"
              className="justify-content-center"
            />
          </Col>
        )}
        <Col className="col-auto font-weight-500 text-color-2">{text}</Col>
      </Row>
    </button>
  );
};

export default ButtonWithBadge;
